import React from 'react';
import { Badge } from '../ui/badge';
import { formatPrice } from '../subscription/PlanPricingTabs';
import { pricingForCycle, formatDiscountBadge, cycleSuffix } from '../../utils/planPricing';

/**
 * SaaS-style price display: selling price, strikethrough default, discount badge, savings.
 */
export default function PlanPriceDisplay({ plan, cycle, size = 'md', showCycleSuffix = true, className = '' }) {
  if (!plan) return null;

  const pricing = pricingForCycle(plan, cycle);
  const currency = plan.currency || 'INR';
  const hasDiscount = pricing.amount_saved > 0;
  const sizeClasses = {
    sm: { selling: 'text-xl', default: 'text-sm', badge: 'text-xs' },
    md: { selling: 'text-3xl', default: 'text-base', badge: 'text-xs' },
    lg: { selling: 'text-4xl', default: 'text-lg', badge: 'text-sm' },
  }[size] || { selling: 'text-3xl', default: 'text-base', badge: 'text-xs' };

  return (
    <div className={`space-y-1 ${className}`}>
      <div className="flex items-end gap-2 flex-wrap">
        <p className={`font-bold leading-none ${sizeClasses.selling}`}>
          {formatPrice(pricing.selling_price, currency)}
          {showCycleSuffix && (
            <span className="text-sm font-normal text-muted-foreground ml-1">{cycleSuffix(cycle)}</span>
          )}
        </p>
        {hasDiscount && (
          <Badge className={`bg-green-600 text-white shrink-0 ${sizeClasses.badge}`}>
            {formatDiscountBadge(pricing.discount_percent)}
          </Badge>
        )}
      </div>
      {hasDiscount && (
        <>
          <p className={`text-muted-foreground line-through ${sizeClasses.default}`}>
            {formatPrice(pricing.default_price, currency)}
          </p>
          <p className="text-sm font-medium text-green-700 dark:text-green-400">
            Save {formatPrice(pricing.amount_saved, currency)}
          </p>
        </>
      )}
    </div>
  );
}
